import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getDictionaries = state => state.dictionaries

export const selectFileCategories = createSelector(
  getDictionaries,
  propOr([], 'fileCategories')
)

export const selectFolders = createSelector(
  getDictionaries,
  propOr([], 'folders')
)
